<div class="topp">
  <div class="velg">
    <mat-chip-listbox multiple [formControl]="filterForm">
      <mat-chip-option value="aktive" data-testid="medlem-filter-aktive">{{ 'Aktiv' | translate }} ({{ antallAktive() }})</mat-chip-option>
      <mat-chip-option value="invitasjoner" data-testid="medlem-filter-invitasjoner">{{ 'Invitasjoner' | translate }} ({{ antallInvitasjoner() }})</mat-chip-option>
      <mat-chip-option value="deaktivert" data-testid="medlem-filter-deaktivert">{{ 'Tilgang stengt' | translate }} ({{ antallDeaktiverte() }})</mat-chip-option>
      <mat-chip-option value="anonymisert" data-testid="medlem-filter-anonymisert">{{ 'Permanent deaktivert' | translate }} ({{ antallAnonymisert() }})</mat-chip-option>
    </mat-chip-listbox>
  </div>

  <div class="handlinger-venstre">
    <button mat-button color="primary" (click)="sendEpostDialog()">
      <mat-icon fontSet="ion-ios-email-outline" class="mat-icon--ionic-ikon"/>
      <span class="knapp-label">{{ "Send e-post" | translate }}</span>
    </button>
    <button mat-button color="primary" (click)="nyttMedlem()">
      <mat-icon fontSet="ion-ios-plus-outline" class="mat-icon--ionic-ikon"/>
      <span class="knapp-label">{{ "Inviter nytt medlem" | translate }}</span>
    </button>
  </div>
</div>
<div class="tabell-kontainer">
  <table mat-table matSort [dataSource]="dataSource" multiTemplateDataRows="true">
    <ng-container matColumnDef="ekspander">
      <th mat-header-cell *matHeaderCellDef class="kolonne-ekspander"></th>
      <td mat-cell *matCellDef="let medlem" class="kolonne-ekspander">
        <button mat-icon-button aria-label="expand row" data-testid="ekspander-knapp" class="mat-medium-icon-button">
          @if (isExpanded(medlem)) {
            <mat-icon>keyboard_arrow_up</mat-icon>
          } @else {
            <mat-icon>keyboard_arrow_down</mat-icon>
          }
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="avatar">
      <th mat-header-cell *matHeaderCellDef class="kolonne-avatar"></th>
      <td mat-cell *matCellDef="let medlem" class="kolonne-avatar">
        <avatar [medlem]="medlem" stil="liten"/>
      </td>
    </ng-container>

    <ng-container matColumnDef="navn">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="kolonne-navn">{{ 'Navn' | translate }}</th>
      <td mat-cell *matCellDef="let medlem" class="kolonne-navn">
        <span class="navn-tekst">{{ medlem.navn }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="rolle">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="kolonne-rolle">{{ 'Rolle' | translate }}</th>
      <td mat-cell *matCellDef="let medlem" class="kolonne-rolle">
        @for (rolle of medlem.aktiveMedlemsroller; track rolle.id) {
          <div class="rolle-tittel">{{ rolle.tittel }}</div>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="rolleStartdato">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="kolonne-rolle-startdato">{{ 'Startdato' | translate }}</th>
      <td mat-cell *matCellDef="let medlem" class="kolonne-rolle-startdato">
        @for (rolle of medlem.aktiveMedlemsroller; track rolle.id) {
          <div class="rolle-startdato">{{ rolle.periode.start | plaindate }}</div>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="rolleSluttdato">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="kolonne-rolle-sluttdato">{{ 'Sluttdato' | translate }}</th>
      <td mat-cell *matCellDef="let medlem" class="kolonne-rolle-sluttdato">
        @for (rolle of medlem.aktiveMedlemsroller; track rolle.id) {
          <div class="rolle-sluttdato">{{ rolle.periode.slutt | plaindate }}</div>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="epost">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="kolonne-epost">{{ 'E-post' | translate }}</th>
      <td mat-cell *matCellDef="let medlem" class="kolonne-epost">
        @if (medlem.epost && !medlem.anonymisert) {
          <a [href]="'mailto:' + medlem.epost" class="epost-lenke">{{ medlem.epost }}</a>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="mobilnummer">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="kolonne-mobilnummer">{{ 'Mobilnummer' | translate }}</th>
      <td mat-cell *matCellDef="let medlem" class="kolonne-mobilnummer">
        @if (medlem.mobilnummer) {
          <a [href]="'tel:' + medlem.mobilnummer" class="mobilnummer-lenke">{{ medlem.mobilnummer | mobilnummer }}</a>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="administrator">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="kolonne-administrator">{{ 'Administrator' | translate }}</th>
      <td mat-cell *matCellDef="let medlem" class="kolonne-administrator">
        @if (medlem.tilgangsroller.includes(TilgangsrolleMedlem.skrive)) {
          <mat-icon>checked</mat-icon>
        } @else {
          <!--            <mat-icon>circle</mat-icon>-->
        }
      </td>
    </ng-container>


    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="kolonne-status">{{ 'Status' | translate }}</th>
      <td mat-cell *matCellDef="let medlem" class="kolonne-status">
        @switch (medlemVisnigsStatus(medlem)) {
          @case ('anonymisert') {
            <span class="status-merke status-merke--anonymisert">
              {{ 'Permanent deaktivert' | translate }}
            </span>
          }
          @case ('deaktivert') {
            <span class="status-merke status-merke--tilgang-stengt">
              {{ 'Tilgang stengt' | translate }}
            </span>
          }
          @case ('invitasjon-sendt') {
            <span class="status-merke status-merke--invitert">
              {{ 'Invitert' | translate }}
            </span>
          }
          @case ('invitasjon-ikke-sendt') {
            <span class="status-merke status-merke--invitert">
              {{ 'Invitasjon ikke sendt' | translate }}
            </span>
          }
          @case ('invitasjon-avslått') {
            <span class="status-merke status-merke--invitert">
              {{ 'Invitasjon avslått' | translate }}
            </span>
          }
          @case ('aktiv') {
            <span class="status-merke status-merke--aktiv">
              {{ 'Aktiv' | translate }}
            </span>
          }
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="meny">
      <th mat-header-cell *matHeaderCellDef class="kolonne-meny">{{ 'Meny' | translate }}</th>
      <td mat-cell *matCellDef="let medlem" class="kolonne-meny">
        @if (medlemVisnigsStatus(medlem) == 'anonymisert') {
          <!--            ingen meny-->
        } @else {
          <button mat-icon-button
                  [matMenuTriggerFor]="medlemMeny"
                  (click)="$event.stopPropagation()"
                  [disabled]="menyDeaktivert()"
                  class="meny-trigger"
                  aria-label="Meny"
                  data-testid="saksmeny-knapp">
            <mat-icon class="material-symbols-fet">more_vert</mat-icon>
          </button>
          <mat-menu #medlemMeny="matMenu" aria-label="{{'Medlemmeny'|translate}}">

            @if (visSendInvitasjon(medlem)) {
              <button mat-menu-item (click)="sendInvitasjon(medlem)">
                <mat-icon>email</mat-icon>
                {{ 'Send invitasjon' | translate }}
              </button>
              <mat-divider></mat-divider>
            }

            @if (visSendInvitasjonIgjen(medlem)) {
              <button mat-menu-item (click)="sendInvitasjonIgjen(medlem)">
                <mat-icon>email</mat-icon>
                {{ 'Send invitasjon på nytt' | translate }}
              </button>
              <mat-divider></mat-divider>
            }

            @if (visRedigerKnapp(medlem)) {
              <button mat-menu-item (click)="rediger(medlem)">
                <mat-icon>edit</mat-icon>
                {{ 'Rediger' | translate }}
              </button>
            }
            @if (visSlettInvitasjon(medlem)) {
              <button mat-menu-item (click)="slettInvitasjon(medlem)">
                <mat-icon>delete</mat-icon>
                {{ 'Slett' | translate }}
              </button>
            }
            @if (visStengTilgangKnapp(medlem)) {
              <button mat-menu-item (click)="stengTilgang(medlem)">
                <mat-icon fontSet="ion-key" class="mat-icon--ionic-ikon"/>
                {{ 'Steng tilgang' | translate }}
              </button>
            }
            @if (visGjenaapneTilgangKnapp(medlem)) {
              <button mat-menu-item (click)="gjenaapneTilgang(medlem)">
                <mat-icon fontSet="ion-key" class="mat-icon--ionic-ikon"/>
                {{ 'Gjenåpne tilgang' | translate }}
              </button>
            }
            @if (visPermanentDeaktivering(medlem)) {
              <button mat-menu-item (click)="permanentDeaktiver(medlem)">
                <mat-icon>no_accounts</mat-icon>
                {{ 'Deaktiver permanent' | translate }}
              </button>
            }
          </mat-menu>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="tomEkspandert">
      <td mat-cell *matCellDef="let medlem" [attr.colspan]="1">
      </td>
    </ng-container>


    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="ekspandertDetaljer">
      <td mat-cell *matCellDef="let medlem" [attr.colspan]="displayedColumns.length-3">
        <div class="detaljer-wrapper"
             [class.detaljer-wrapper-ekspandert]="isExpanded(medlem)">
          <div class="detaljer">
            <div>
              <tittel-verdi-samling stil="horisontal">
                <tittel-verdi stil="horisontal">
                  <tittel><i class="ion-ios-email-outline"></i></tittel>
                  <verdi>
                    @if (medlem.epost && !medlem.anonymisert) {
                      <a [href]="'mailto:' + medlem.epost" class="epost-lenke">{{ medlem.epost }}</a>
                    }
                  </verdi>
                </tittel-verdi>
                <tittel-verdi stil="horisontal">
                  <tittel><i class="ion-ios-telephone-outline"></i></tittel>
                  <verdi>
                    @if (medlem.mobilnummer) {
                      <a [href]="'tel:' + medlem.mobilnummer" class="mobilnummer-lenke">{{ medlem.mobilnummer | mobilnummer }}</a>
                    }
                  </verdi>
                </tittel-verdi>
                <tittel-verdi stil="horisontal">
                  <tittel><i class="ion-ios-world-outline"></i></tittel>
                  <verdi>
                    @if (medlem.spraak) {
                      <lokale [lokale]="medlem.spraak"/>
                    }
                  </verdi>
                </tittel-verdi>
                <tittel-verdi stil="horisontal">
                  <tittel><i class="ion-ios-time-outline"></i></tittel>
                  <verdi>
                    @if (medlem.tidssone) {
                      <tidssone [tidssone]="medlem.tidssone"/>
                    }
                  </verdi>
                </tittel-verdi>
              </tittel-verdi-samling>
            </div>
            <div class="roller">
              <ramme-med-tittel [tittel]="'Roller'|translate" class="rolleperioder">
                <ramme-innhold>
                  @for (rolle of medlem.aktiveMedlemsroller; track rolle.id) {
                    <div class="rolleperiode e2e-rolleperiode">
                      <div class="tittel e2e-tittel">{{ rolle.tittel }}</div>
                      <div class="periode e2e-periode">{{ rolle.periode | datoperiodeutentid }}</div>
                    </div>
                  }
                  @for (rolle of medlem.inaktiveMedlemsroller; track rolle.id) {
                    <div class="rolleperiode">
                      <div class="tittel">{{ rolle.tittel }}</div>
                      <div class="periode">{{ rolle.periode | datoperiodeutentid }}</div>
                    </div>
                  }
                </ramme-innhold>
              </ramme-med-tittel>
              <ramme-med-tittel [tittel]="'Brukertilgang'|translate" class="tilgangsroller">
                <ramme-innhold>
                  <div class="tilganger">
                    <ul>
                      @for (tilgang of tilgangsroller(); track tilgang.rolle; ) {
                        <li [matTooltip]="tilgang.subtittel(enumOversettelser)">
                          {{ tilgang.tittel(enumOversettelser) }}
                        </li>
                      }
                    </ul>
                  </div>
                </ramme-innhold>
              </ramme-med-tittel>
            </div>
          </div>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="ekspandertDetaljerStatus">
      <td mat-cell *matCellDef="let medlem" [attr.colspan]="2">
        <div class="detaljer-wrapper"
             [class.detaljer-wrapper-ekspandert]="isExpanded(medlem)">
          <div class="detaljer">
            <div>
              @switch (medlemVisnigsStatus(medlem)) {
                @case ('anonymisert') {
                  <span>
                    {{ 'Deaktivert {dato}' | translate:{dato: medlem.medlemstatusSistEndret | zoneddatetime} }}
                  </span>
                }
                @case ('deaktivert') {
                  <span>
                    {{ 'Tilgang stengt {dato}' | translate:{dato: medlem.medlemstatusSistEndret | zoneddatetime} }}
                  </span>
                }
                @case ('invitasjon-sendt') {
                  <span>
                    {{ 'Lagt til {dato}' | translate:{dato: medlem.medlemstatusSistEndret | zoneddatetime} }}
                  </span>
                }
                @case ('invitasjon-ikke-sendt') {
                  <span>
                    {{ 'Lagt til {dato}' | translate:{dato: medlem.medlemstatusSistEndret | zoneddatetime} }}
                  </span>
                }
                @case ('invitasjon-avslått') {
                  <span>
                    {{ 'Lagt til {dato}' | translate:{dato: medlem.medlemstatusSistEndret | zoneddatetime} }}
                  </span>
                }
                @case ('aktiv') {
                  <!--                  nada-->
                }
              }
            </div>
          </div>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let medlem; columns: displayedColumns;" class="medlem-rad"
        [class.detaljer-rad]="isExpanded(medlem)"
        (click)="toggle(medlem)">>
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['tomEkspandert', 'ekspandertDetaljer','ekspandertDetaljerStatus']" class="detaljer-rad"></tr>
  </table>
</div>

<ng-template #bekreftSlettInvitasjonDialogInnhold let-medlemNavn="medlemNavn">
  <p>
    {{ 'Du er i ferd med å slette invitasjonen til'|translate }}
    <span class="std-fet">{{ medlemNavn }}</span>
    {{ 'i {gruppe} i {organisasjon}'|translate: {gruppe: gruppe()!.tittel, organisasjon: gruppe()!.organisasjonsnavn} }}.
  </p>
  <inline-melding type="feil">{{ 'Merk at slettingen ikke kan angres.'|translate }}</inline-melding>
</ng-template>


